function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalreward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 503.607 503.607",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDD09"
    },
    d: "M384.521,192.049l-142.689,41.967L200.704,30.056c-3.357-10.911,4.197-22.662,15.948-22.662h105.757 c6.715,0,13.43,4.197,15.948,10.911l56.236,151.921C397.111,179.459,392.914,189.531,384.521,192.049"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M136.075,168.548l38.61-116.669l-9.233-22.662c-0.839-2.518-0.839-4.197-0.839-6.715 l-45.325,136.813c-3.357,8.393,1.679,18.466,10.072,20.984l9.233,3.357C135.235,179.459,134.396,174.423,136.075,168.548"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD9808"
    },
    d: "M369.412,160.154l-49.521-141.01c-2.518-6.715-8.393-11.751-15.948-11.751h-25.18 c7.554,0,13.43,5.036,15.948,11.751l56.236,151.921c1.679,5.036,0.839,10.072-1.679,13.43l9.233-3.357 C367.734,177.78,371.93,168.548,369.412,160.154"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDD09"
    },
    d: "M345.071,192.049L244.35,225.623L161.255,30.056c-3.357-10.911,4.197-22.662,15.948-22.662H282.96 c7.554,0,13.43,4.197,15.948,10.911l56.236,151.921C357.662,179.459,353.465,189.531,345.071,192.049"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDD09"
    },
    d: "M178.042,39.289c-0.839-2.518-0.839-4.197-0.839-6.715l-45.325,136.813 c-3.357,8.393,1.679,18.466,10.072,20.984l102.4,35.252L178.042,39.289z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1CD759"
    },
    points: "328.285,194.567 261.137,7.393 227.563,7.393 298.908,205.479  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1CD759"
    },
    points: "192.311,103.918 160.416,194.567 189.793,205.479 210.776,147.564  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#110E0E"
    },
    d: "M244.35,234.016c-0.839,0-1.679,0-3.357-0.839l-118.348-43.646 c-12.59-5.036-19.305-19.305-15.108-31.895l10.911-35.252c1.679-4.197,5.875-6.715,10.911-5.036 c5.036,1.679,6.715,5.875,5.036,10.911l-11.751,35.252c-1.679,4.197,0.839,9.233,5.036,10.911l100.721,37.77L160.416,50.2 l-9.233,26.859c-0.839,5.036-5.875,7.554-10.072,5.875c-4.197-1.679-6.715-6.715-5.875-10.911l16.787-51.2 c1.679-4.197,5.036-6.715,9.233-5.875c5.036,0.839,7.554,5.036,7.554,9.233c0,0.839,0,2.518,0,3.357l83.095,195.567 c1.679,3.357,0.839,6.715-1.679,9.233C248.547,233.177,246.868,234.016,244.35,234.016z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#110E0E"
    },
    d: "M143.629,99.721c0-5.036-3.357-8.393-8.393-8.393s-8.393,3.357-8.393,8.393 s3.357,8.393,8.393,8.393S143.629,104.757,143.629,99.721"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDD09"
    },
    d: "M252.744,301.164c-18.466,0-33.574-15.108-33.574-33.574s15.108-33.574,33.574-33.574 s33.574,15.108,33.574,33.574S271.209,301.164,252.744,301.164z M252.744,250.803c-9.233,0-16.787,7.554-16.787,16.787 s7.554,16.787,16.787,16.787c9.233,0,16.787-7.554,16.787-16.787S261.976,250.803,252.744,250.803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDD09"
    },
    d: "M319.891,393.492c0-55.397-33.574-100.721-75.541-100.721s-75.541,45.325-75.541,100.721 s33.574,100.721,75.541,100.721S319.891,449.728,319.891,393.492"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M168.809,393.492c0-55.397,33.574-100.721,75.541-100.721c-55.397,0-100.721,45.325-100.721,100.721 s45.325,100.721,100.721,100.721C202.383,494.213,168.809,449.728,168.809,393.492"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD9808"
    },
    d: "M244.35,292.77c41.967,0,75.541,45.325,75.541,100.721s-33.574,100.721-75.541,100.721 c55.397,0,100.721-45.325,100.721-100.721S299.747,292.77,244.35,292.77"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#110E0E"
    },
    d: "M177.203,401.885c-5.036,0-8.393-3.357-8.393-8.393c0-41.967,33.574-75.541,75.541-75.541 c5.036,0,8.393,3.357,8.393,8.393c0,5.036-3.357,8.393-8.393,8.393c-32.734,0-58.754,26.02-58.754,58.754 C185.596,398.528,182.239,401.885,177.203,401.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#110E0E"
    },
    d: "M244.35,502.607c-60.433,0-109.115-48.682-109.115-109.115s48.682-109.115,109.115-109.115 s109.115,48.682,109.115,109.115S304.783,502.607,244.35,502.607z M244.35,301.164c-51.2,0-92.328,41.967-92.328,92.328 s41.128,92.328,92.328,92.328s92.328-41.128,92.328-92.328S295.55,301.164,244.35,301.164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#110E0E"
    },
    d: "M244.35,267.59c-5.036,0-8.393-3.357-8.393-8.393v-33.574c0-5.036,3.357-8.393,8.393-8.393 s8.393,3.357,8.393,8.393v33.574C252.744,264.233,249.386,267.59,244.35,267.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#110E0E"
    },
    d: "M244.35,301.164c-18.466,0-33.574-15.108-33.574-33.574s15.108-33.574,33.574-33.574 s33.574,15.108,33.574,33.574S262.816,301.164,244.35,301.164z M244.35,250.803c-9.233,0-16.787,7.554-16.787,16.787 s7.554,16.787,16.787,16.787s16.787-7.554,16.787-16.787S253.583,250.803,244.35,250.803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#110E0E"
    },
    d: "M244.35,234.016c-3.357,0-6.715-1.679-7.554-5.036L153.701,33.413 c-2.518-8.393-1.679-16.787,3.357-23.502C161.255,3.197,168.809-1,177.203-1H308.14c10.911,0,20.144,6.715,23.502,16.787 l49.521,141.01c4.197,12.59-2.518,26.859-15.108,31.895l0,0l-118.348,45.325C246.029,234.016,245.19,234.016,244.35,234.016z  M177.203,15.787c-2.518,0-5.036,1.679-6.715,4.197c-1.679,1.679-2.518,5.036-0.839,7.554l79.738,188.013l111.633-41.967l0,0 c4.197-1.679,6.715-6.715,5.036-10.911l-50.361-141.01c-0.839-3.357-4.197-5.875-7.554-5.875H177.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#110E0E"
    },
    d: "M298.908,213.872c-0.839,0-2.518,0-3.357-0.839c-1.679-0.839-3.357-2.518-4.197-5.036 L220.009,10.751c-0.839-2.518-0.839-5.036,0.839-7.554C222.527,0.679,225.045-1,227.563-1h33.574c3.357,0,6.715,2.518,7.554,5.875 l67.148,186.334c1.679,4.197-0.839,9.233-5.036,10.911l-30.216,10.911C300.586,213.872,299.747,213.872,298.908,213.872z  M239.314,15.787l63.79,178.78l14.269-5.036L255.262,15.787H239.314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#110E0E"
    },
    d: "M189.793,213.872c-0.839,0-1.679,0-3.357-0.839l-30.216-10.911 c-3.357-1.679-5.875-6.715-4.197-10.911l32.734-90.649c0.839-3.357,4.197-5.036,7.554-5.875c3.357,0,6.715,1.679,7.554,5.036 l18.466,42.807c0.839,1.679,0.839,4.197,0,5.875l-20.984,58.754c-0.839,2.518-2.518,4.197-4.197,5.036 C192.311,213.872,191.471,213.872,189.793,213.872z M170.488,189.531l14.269,5.036l16.787-47.003l-8.393-20.144L170.488,189.531z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalreward);
export default __webpack_public_path__ + "static/media/medalreward.1943781bc4bbfa6917f99442f7a00ae7.svg";
export { ForwardRef as ReactComponent };